import { render, staticRenderFns } from "./productcard.vue?vue&type=template&id=2ae42862&"
import script from "./productcard.vue?vue&type=script&lang=ts&"
export * from "./productcard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae42862')) {
      api.createRecord('2ae42862', component.options)
    } else {
      api.reload('2ae42862', component.options)
    }
    module.hot.accept("./productcard.vue?vue&type=template&id=2ae42862&", function () {
      api.rerender('2ae42862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/productcard.vue"
export default component.exports